import React from "react";
import { useStateContext } from "../Contexts/ContextProvider";
import MantineText from "./mantine/text";
import MantineFlex from "./mantine/flex";
import MantineDivider from "./mantine/divider";
import { sideBarBgImage, themeColors } from "../helpers/constant";
import MantineButton from "./mantine/button";
import MantineCloseButton from "./mantine/closeButton";
import { MantineTab, MantineTabList, MantineTabsTab } from "./mantine/tab";
import { IconCheck } from "@tabler/icons-react";
import MantineImage from "./mantine/image";
import MantineColorSwatch from "./mantine/colorSwatch";
import { useCustomMediaQuery } from "../helpers/common";

const ThemeSettings = () => {
    const {
        handleColorPrimary,
        handleSecondaryColor,
        currentPrimaryColor,
        setThemeSettings,
        currentOrientation,
        setOrientation,
        currentSecondaryColor,
        handleTerritoryColor,
        handleCurrentImage,
        currentBgImage,
        opensideBar,
        handlecurrentIconType
    } = useStateContext();
    const { isSmallScreen, isMediumScreen, isLargeScreen, isSmallScreenTablet } = useCustomMediaQuery();

    const renderThemeOptions = () => {
        return themeColors.map((item, index) => (
            <div className="mt-2 cursor-pointer flex gap-5 items-center" key={index}>
                <MantineButton
                    type="button"
                    className="h-10 w-10 rounded-full cursor-pointer !p-0"
                    style={{ backgroundColor: item.color }}
                    onClick={() => {
                        handleColorPrimary(item.color);
                        handleTerritoryColor(item.territory_color);
                        handleSecondaryColor(item.secondary_color);
                    }}
                >
                    <IconCheck size={14} className={item.color === currentPrimaryColor ? "block" : "hidden"} />
                </MantineButton>
            </div>
        ));
    };

    const renderBackgroundImages = () => {
        return (
            <>
                {sideBarBgImage.map((img, index) => (
                    <div key={index} className="relative" onClick={() => { handleCurrentImage(img.name) }}>
                        <div className="bg-indigo-300 hover:opacity-25 cursor-pointer rounded-md">
                            <MantineImage src={img.src} className="w-[40px] h-[80px] !bg-indigo-500 opacity-500 rounded-md" />
                        </div>
                        <div
                            className={`${img.name === currentBgImage && 'bg-sidebar_image_overlay_color'} cursor-pointer content-none !absolute top-0 left-0 h-[80px] w-[40px] relative rounded-md`}
                        >
                            <div className="absolute top-[40%] left-[28%]">
                                <IconCheck size={14} className={img.name === currentBgImage ? "block" : "hidden"} color="white" />
                            </div>
                        </div>
                    </div>
                ))}
                <MantineColorSwatch color={"#eff2f7"} className="w-[40px] h-[80px]" radius={"md"}>
                    <div
                        onClick={() => handleCurrentImage("none")}
                        className={`${"none" === currentBgImage && 'bg-sidebar_image_overlay_color'} rounded-md cursor-pointer content-none absolute top-0 left-0 h-[80px] w-[40px] relative`}
                    >
                        <div style={{
                            writingMode: 'vertical-rl',
                            textOrientation: 'upright',
                            textAlign: 'center',
                            paddingLeft: '10px'
                        }} className="font-semibold leading-5 text-center pt-2">None</div>
                        <div className="absolute top-[40%] left-[30%]">
                            <IconCheck size={14} className={"none" === currentBgImage ? "block" : "hidden rounded-md"} color="white" />
                        </div>
                    </div>
                </MantineColorSwatch>
            </>
        );
    };

    const renderOrientationTabs = () => {
        return (
            <MantineTab variant="unstyled" defaultValue={"horizontal"}>
                <MantineTabList>
                    <div
                        className={`w-1/2 border border-solid border-gray-200 rounded-tl-md rounded-bl-md ${currentOrientation === "horizontal" ? 'text-white' : ''}`}
                        style={{ background: currentOrientation === "horizontal" ? currentPrimaryColor : 'transparent' }}
                    >
                        <MantineTabsTab value="horizontal" onClick={() => setOrientation("horizontal")}>
                            Horizontal
                        </MantineTabsTab>
                    </div>
                    <div
                        className={`w-1/2 border border-solid border-gray-200 rounded-tr-md rounded-br-md ${currentOrientation === "vertical" ? 'text-white' : ''}`}
                        style={{ background: currentOrientation === "vertical" ? currentPrimaryColor : 'transparent' }}
                    >
                        <MantineTabsTab value="vertical" onClick={() => setOrientation("vertical")}>
                            Vertical
                        </MantineTabsTab>
                    </div>
                </MantineTabList>
            </MantineTab>
        );
    };

    const renderIconTabs = () => {
        return (
            <MantineTab variant="unstyled" defaultValue={"default"}>
                <MantineTabList>
                    <div
                        className={`w-1/2 border border-solid border-gray-200 rounded-tl-md rounded-bl-md ${opensideBar === "default" ? 'text-white' : ''}`}
                        style={{ background: opensideBar === "default" ? currentPrimaryColor : 'transparent' }}
                    >
                        <MantineTabsTab value="default" onClick={() => handlecurrentIconType("default")}>
                            Default
                        </MantineTabsTab>
                    </div>
                    <div
                        className={`w-1/2 border border-solid border-gray-200 rounded-tr-md rounded-br-md ${opensideBar === "icon" ? 'text-white' : ''}`}
                        style={{ background: opensideBar === "icon" ? currentPrimaryColor : 'transparent' }}
                    >
                        <MantineTabsTab value="icon" onClick={() => handlecurrentIconType("icon")}>
                            Icon
                        </MantineTabsTab>
                    </div>
                </MantineTabList>
            </MantineTab>
        );
    };

    return (
        <div className="bg-half_transparent w-screen fixed top-0 right-0 z-50">
            <div className={`float-right h-screen bg-white ${isSmallScreen || isMediumScreen ? 'w-full max-w-sm' : 'w-[18%]'} ${isLargeScreen && 'w-full max-w-sm'} p-4`}>
                <MantineFlex className="justify-between">
                    <MantineText name="Settings" className="font-semibold text-xl" />
                    <MantineCloseButton onClick={() => setThemeSettings(false)} />
                </MantineFlex>
                <MantineDivider my="md" color={currentSecondaryColor} />
                {/* Orientation tab concept start */}
                <div>
                    <div className="flex-col border-t-1 border-color p-4 ml-4">
                        <MantineText name="Orientation" className="font-semibold text-lg text-center" />
                    </div>
                    {renderOrientationTabs()}
                </div>
                {/* Orientation tab concept end */}
                <MantineDivider my="md" color={currentSecondaryColor} />
                {/* color theme options concept start */}
                <div>
                    <div className="flex-col border-t-1 border-color p-4 ml-4">
                        <MantineText name="Theme Option" className="font-semibold text-lg text-center" />
                    </div>
                    <MantineFlex className="justify-between">
                        {renderThemeOptions()}
                    </MantineFlex>
                </div>
                {/* color theme options concept end */}
                {/* <MantineDivider my="md" color={currentSecondaryColor} /> */}
                {/* background image theme options concept start */}
                {/* future enbale hide bg image */}
                {/* <div>
                    <div className="flex-col border-t-1 border-color p-4 ml-4">
                        <MantineText name="Left Sidebar Bg Image" className="font-semibold text-lg text-center" />
                    </div>
                    <MantineFlex className="justify-between">
                        {renderBackgroundImages()}
                    </MantineFlex>
                </div> */}
                {/* background image theme options concept end */}
                {/* <MantineDivider my="md" color={currentSecondaryColor} /> */}
                {/* side bar default and icon based theme options concept start */}
                {/* <div>
                    {!isSmallScreenTablet &&
                        <>
                            {currentOrientation == 'vertical' &&

                                <>
                                    <MantineDivider my="md" color={currentSecondaryColor} />
                                    <div className="flex-col border-t-1 border-color p-4 ml-4">
                                        <MantineText name="Left Sidebar Type" className="font-semibold text-lg text-center" />
                                    </div>
                                    {renderIconTabs()}
                                </>
                            }
                        </>
                    }
                </div> */}
                {/* side bar default and icon based theme options concept end */}
            </div>
        </div >
    );
};

export default ThemeSettings;
